import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  ColDef,
  ColumnApi, GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  IServerSideGetRowsParams, RowClassRules, SetFilterValuesFuncParams,
  ValueFormatterParams
} from 'ag-grid-community';
import {Observable} from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import {shareReplay} from 'rxjs/operators';
import {LogsToolPanelComponent} from '../components/logs-tool-panel/logs-tool-panel.component';
import {environment} from '../../../environments/environment';
import {ConfirmationCellComponent} from '../components/confirmation-cell/confirmation-cell.component';
import {GridService} from '../../services/grid.service';
import {HttpService} from '../../services/http.service';
import { StorageService } from 'src/app/services/storage.service';
import {CellEditorTagsComponent} from '../cell-editors/cell-editor-tags/cell-editor-tags.component';
import {DateComponentComponent} from '../components/date-component/date-component.component';
import {CellEditorBrandComponent} from '../cell-editors/cell-editor-brand/cell-editor-brand.component';
import {CellEditorTypeComponent} from '../cell-editors/cell-editor-type/cell-editor-type.component';
import {ObsoleteComponent} from '../dialogs/obsolete/obsolete.component';
import { SharedService } from 'src/app/services/shared.service';
import {HistoryDialogComponent} from '../dialogs/history-dialog/history-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {InfoService} from '../../services/info.service';
import {AdminToolPanelComponent} from '../components/admin-tool-panel/admin-tool-panel.component';
import {LocalStorageService} from '../../services/local-storage.service';

@Component({
  selector: 'app-grid-logs',
  templateUrl: './grid-logs.component.html',
  styleUrls: ['./grid-logs.component.scss']
})
export class GridLogsComponent implements OnInit, OnDestroy {
  public readonly paginationPageSize = 1000;
  public readonly cacheBlockSize = 300;
  public readonly maxBlocksInCache = 10;
  public readonly maxConcurrentDatasourceRequests = 1;
  public readonly rowModelType = 'serverSide';
  public readonly autoGroupColumnDef: ColDef = {flex: 2, filter: false, sortable: false};
  public readonly overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait...</span>';
  private gridReady: boolean = false;

  public user$: Observable<any>;
  public defaultColDef: ColDef = {
    resizable: true,
    flex: 1,
    minWidth: 120,
    sortable: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab'],
    filterParams: {
      buttons: ['reset'],
    },
    // enableRowGroup: true,
    cellClass: (params: any) => {
      const cellChanged = params.data?.fields_status?.[params.colDef.field] === 20;
      const cellLock = params.data.locked !== undefined && Object.keys(params.data.locked).length > 0;
      const cellLockOtherUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id !== this.authService.currentUserValue?._id: false;
      const cellLockCurrentUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id === this.authService.currentUserValue._id: false;
      const cellPrice = (params.colDef.field === 'list_price' || params.colDef.field === 'cost_price'  || params.colDef.field === 'sell_price' || params.colDef.field === 'mws_sell_price');

      // if (cellPrice && cellChanged && params.data.new !== true) {
      if (cellPrice && cellChanged) {
        return ['number-cell', 'ag-cell-changed'];
      // } else if (cellChanged && params.data.new !== true) {
      } else if (cellChanged) {
        if (cellLockOtherUsers) {
          return '';
        }
        return 'ag-cell-changed';
      } else if (params.colDef.field === 'sku') {
        return 'sku-col';
      } else if (cellPrice) {
        return 'number-cell';
      }

      return '';
    }
  }
  public rowData$!: Observable<any[]>;
  public readonly rowSelection = 'multiple';
  public readonly sideBar = {
    // defaultToolPanel: 'logsPanel',
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
        }
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressExpandAll: false,
          suppressFilterSearch: false
        }
      },
      // {
      //   id: 'logsPanel',
      //   labelDefault: 'Changes',
      //   labelKey: 'logsPanel',
      //   iconKey: '',
      //   toolPanel: LogsToolPanelComponent,
      //   width: 297,
      //   maxWidth: 297,
      // },
    ],
  };
  public rowClassRules: RowClassRules = {
    // 'confirm-changes': (params) => {
    //   return !!(params.data && params.data.status === 30);
    // },
    // 'conflict-changes': (params) => {
    //   return !!(params.data && params.data.status === 50);
    // },
    // 'reject-changes': (params) => {
    //   return !!(params.data && params.data.status === 40);
    // },
    'handle-error': (params) => {
      return !!(params.data && params.data.handle.length === 0);
    },
    // 'import-product': (params) => {
    //   return !!(params.data && params.data.new);
    // },
    'editing-row': (params) => {
      if (params.data && params.data.locked && params.data.locked.user && (params.data.locked.user._id !== this.authService.currentUserValue._id)) {
        return true;
      } else {
        return false;
      }
    },
    // 'push-changes': (params) => {
    //   return !!(params.data && params.data.history.accepted_status === 4);
    // }
  }
  public columnDefs: ColDef[] = this.sharedService.columnDefs;
  public columnDefs2: ColDef[] = [
    {
      field: 'id',
      // filter: 'agTextColumnFilter',
      hide: true,
      editable: false,
      // filter: 'agSetColumnFilter',
      filter: 'agTextColumnFilter',
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'confirm',
      headerName: 'Сonfirmation',
      cellRenderer: ConfirmationCellComponent,
      pinned: true,
      maxWidth: 180,
      suppressNavigable: true,
      sortable: false,
      cellClass: 'no-border',
    },
    {
      field: 'user_name',
      headerName: 'Changed By',
      minWidth: 130,
      sortable: false,
      filter: 'agTextColumnFilter',
      cellRenderer: (cell: any) => {
        return cell.data.users_activity?.map((u: any) => u.name).join(', ');
      }
    },
    {
      field: 'updated_at',
      headerName: 'Modification date',
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['Greater than or equals', 'Less Than or equals'],
        // filterOptions: [],
        hide: true,
      },
      minWidth: 190,
      valueFormatter: (data: any) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() + ' ' + (new Date(data.value)).toLocaleTimeString() : '';
      }
    },
    // {
    //   // field: 'history',
    //   // rowGroup: true,
    //   // valueFormatter: (cell: any) => {
    //   //   console.log(cell);
    //   //   return '123';
    //   // },
    // },
    {
      field: 'status',
      headerName: 'status',
      editable: false,
      hide: true,
      filter: 'agTextColumnFilter',
      suppressMenu: false,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      menuTabs: ['columnsMenuTab'],
      enablePivot: false,
      enableValue: false,
      enableRowGroup: false,
      sortable: false
    },
    {
      field: 'sku',
      headerName: 'SKU',
      // checkboxSelection: true,
      // rowGroup: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply','reset'],
        debounceMs: 1000,
        suppressAndOrCondition: true,
      },
      minWidth: 200,
      // cellRenderer: (cell: any) => {
      //   if (cell.value) {
      //     return cell.value;
      //   } else {
      //     return cell.data?.product['sku']
      //   }
      // },
    },
    {
      field: 'shopify_published',
      headerName: 'Shopify Published',
      minWidth: 170,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        valueFormatter: (cell: any) => {
          return cell.data && cell.data?.product['shopify_published'] === true;
        }
      },
      // cellRenderer: (cell: any) => {
      //   console.log('cell', cell);
      //   if (cell.value) {
      //     return cell.value;
      //   } else {
      //     return cell.data?.product['shopify_published']
      //   }
      // },
    },
    {
      field: 'amazon_published',
      headerName: 'Amazon Published',
      minWidth: 180,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        valueFormatter: (cell: any) => {
          return cell.data && cell.data?.product['amazon_published'] === true;
        }
      },
      // cellRenderer: (cell: any) => {
      //   if (cell.value) {
      //     return cell.value;
      //   } else {
      //     return cell.data?.product['amazon_published']
      //   }
      // },
    },
    {
      field: 'replacement',
      headerName: 'Replacement SKU',
      filter: 'agTextColumnFilter',
      minWidth: 170,
      filterParams: {
        filterOptions: ['Equals', 'Not Equals', 'Contains', 'Greater Than', 'Less Than'],
      },
      cellRenderer: (cell: any) => {
        if (cell.data.replacement?.obsolete && !cell.data.replacement?.sku) {
          return 'Obsolete / NO replacement';
        } else {
          return cell.data.replacement?.sku;
        }
      }
    },
    {
      field: 'handle',
      headerName: 'Handle',
      minWidth: 190,
      filter: 'agTextColumnFilter',
      // cellRenderer: (cell: any) => {
      //   if (cell.value) {
      //     return cell.value;
      //   } else {
      //     return cell.data?.product['handle']
      //   }
      // },
    },
    {
      field: 'brand',
      headerName: 'Brand',
      cellEditor: CellEditorBrandComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        // return this.storageService.brands.find(b => b._id === cell.value._id) ? this.storageService.brands.find(b => b._id === cell.value._id).name : null;
        return cell.value.name;
      },
      // valueSetter: (params: ValueSetterParams) => {
      //   console.log('valueSetter', params);
      //   return true;
      // },
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.brands.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.brands.find(b => b._id === cell.value)) {
            return this.storageService.brands.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 130,
      cellEditor: CellEditorTypeComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        // return this.storageService.types.find(b => b._id === cell.value._id) ? this.storageService.types.find(b => b._id === cell.value._id).name : null;
        return cell.value?.name;
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        suppressSorting: true,
        values: (params: SetFilterValuesFuncParams) => {
          params.success(this.storageService.types.map(b => b._id));
        },
        valueFormatter: (cell: any) => {
          if (this.storageService.types.find(b => b._id === cell.value)) {
            return this.storageService.types.find(b => b._id === cell.value).name;
          } else {
            return null;
          }
        }
      }
    },
    {
      field: 'description',
      headerName: 'Description',
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      minWidth: 340,
    },
    {
      field: 'list_price',
      headerName: 'List Price',
      minWidth: 130,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
      },
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return null;
        }
      },
    },
    {
      field: 'cost_price',
      headerName: 'Cost Price',
      minWidth: 130,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
      },
      cellRenderer: (cell: any) => {
        // return cell.value;
        if (cell.value) {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return null;
        }
      },
    },
    {
      field: 'sell_price',
      headerName: 'Sell Price',
      minWidth: 130,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
      },
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return '$' + parseFloat(cell.value).toFixed(2).toString();
        } else {
          return null;
        }
      },
    },
    {
      field: 'pack_qty',
      headerName: 'Pack Qty',
      maxWidth: 130,
      filter: 'agNumberColumnFilter',
    },
    // {
    //   field: 'pack_text',
    //   headerName: 'Pack Text',
    //   filter: 'agTextColumnFilter',
    //   filterParams: {
    //     suppressAndOrCondition: true,
    //     filterOptions: ['contains']
    //   },
    // },
    // {
    //   field: 'asm_origin_zip',
    //   headerName: 'ASM Origin-Zip',
    //   filter: 'agTextColumnFilter',
    //   filterParams: {
    //     suppressAndOrCondition: true,
    //     filterOptions: ['contains']
    //     // filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual'],
    //   },
    // },
    {
      field: 'image',
      headerName: 'Image',
      minWidth: 270,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
    },
    {
      field: 'datasheet',
      headerName: 'Datasheet',
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
    },
    {
      field: 'installation_instructions',
      headerName: 'Installation Instructions',
      minWidth: 400,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
    },
    {
      field: 'url_manufacturer',
      headerName: 'URL Manufacturer',
      minWidth: 300,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
    },
    {
      field: 'body_seo',
      headerName: 'Body',
      minWidth: 500,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      }
    },
    {
      field: 'tags',
      headerName: 'Tags',
      minWidth: 400,
      cellEditor: CellEditorTagsComponent,
      cellEditorPopup: true,
      cellRenderer: (cell: any) => {
        let tags: any = [];
        cell.value?.forEach((tag: any) => {
          const name = this.storageService.tagMap.get(tag._id);
          if (name) {
            tags.push(name);
          }
        });
        return tags.join(', ');
      },
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      }
    },
    {
      field: 'google_category',
      headerName: 'Google Category',
      minWidth: 170,
      filter: 'agNumberColumnFilter',
    },
    {
      field: 'weight_lbs',
      headerName: 'Weight LBS',
      minWidth: 170,
      filter: 'agNumberColumnFilter',
      cellRenderer: (cell: any) => {
        if (cell.value) {
          return parseFloat(cell.value).toFixed(2).toString();
        } else {
          return null;
        }
      },
    },
    {
      field: 'title_prefix_1',
      headerName: 'Title Prefix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'title_prefix_2',
      headerName: 'Title Prefix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'title_prefix_3',
      headerName: 'Title Prefix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'title_suffix_1',
      headerName: 'Title Suffix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'title_suffix_2',
      headerName: 'Title Suffix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'title_suffix_3',
      headerName: 'Title Suffix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'body_prefix_1',
      headerName: 'Body Prefix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'body_prefix_2',
      headerName: 'Body Prefix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'body_prefix_3',
      headerName: 'Body Prefix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'body_suffix_1',
      headerName: 'Body Suffix 1',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'body_suffix_2',
      headerName: 'Body Suffix 2',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    },
    {
      field: 'body_suffix_3',
      headerName: 'Body Suffix 3',
      minWidth: 170,
      filter: 'agTextColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        filterOptions: ['contains']
      },
      cellRenderer: (cell: any) => {
        return cell.value?.replace( /(<([^>]+)>)/ig, '');
      },
    }
  ];
  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    // let restoreValue: any = null;
    const cellId: any = params.column?.getId();
    const disableHistoryBtn = params.node?.data.logs[cellId] === false;
    // if (params.node?.data.logs.length) {
    //   restoreValue = {
    //     name: 'Restore Previous Values',
    //     disabled: false,
    //     icon: '<span class="ag-icon ag-icon-first" unselectable="on" role="presentation"></span>',
    //     action: () => {
    //       // this.cancelLastChange({
    //       //   product_id: params.node?.data.id,
    //       //   field_name: params?.column?.getId()
    //       // });
    //     }
    //   }
    // }
    return [
      {
        name: 'Open BHS Shopify Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      'separator',
      {
        name: 'Open MWS Shopify Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://midwestsupplyus.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      'separator',
      {
        name: 'Auto Size Column',
        icon: '<span class="ag-icon ag-icon-maximize" unselectable="on" role="presentation"></span>',
        action: () => {
          const colId: any = params.column?.getId();
          this.gridService.changesColumnApi?.autoSizeColumn(colId);
        }
      },
      {
        name: 'Pin Row',
        icon: '<span class="ag-icon ag-icon-pin" unselectable="on" role="presentation"></span>',
        action: () => {
          const colId: any = params.column?.getId();
          this.gridService.changesGridApi?.setPinnedTopRowData([params?.node?.data]);
        }
      },
      {
        name: 'History',
        icon: '<span class="ag-icon ag-icon-group" unselectable="on" role="presentation"></span>',
        disabled: disableHistoryBtn,
        action: () => {
          this.dialog.open(HistoryDialogComponent, {
            width: '90%',
            maxWidth: '1024px',
            disableClose: true,
            data: {
              params,
              sku: params.node?.data.sku,
              column: params.column?.getColDef().headerName,
              product_id: params.node?.data._id,
              field: params.column?.getId()
            }
          });
        }
      },
      // restoreValue,
    ];
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private gridService: GridService,
    private httpService: HttpService,
    private storageService: StorageService,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private infoService: InfoService,
    private localStorageService: LocalStorageService
  ) {
    this.user$ = this.authService.getCurrentUser().pipe(
      shareReplay()
    );
  }

  ngOnInit(): void {
    this.user$.subscribe(res => {
      // if (res && res.access.level === 1) {
      //   const toolPanel: any = {
      //     id: 'adminPanel',
      //     labelDefault: 'Admin',
      //     labelKey: 'customStats',
      //     iconKey: 'columnMoveMove',
      //     toolPanel: AdminToolPanelComponent,
      //     width: 400,
      //     maxWidth: 400,
      //   }
      //
      //   this.sideBar.toolPanels.push(toolPanel);
      //   setTimeout(() => {
      //     this.gridService.changesGridApi?.refreshToolPanel();
      //     this.gridService.changesGridApi?.setSideBar(this.sideBar);
      //   }, 500);
      // }
    });

    const confirmationRow = this.columnDefs.find(x => x.field === 'confirm');
    const pushedAtRow = this.columnDefs.find(x => x.field === 'pushed_at');
    const pushedUserRow = this.columnDefs.find(x => x.field === 'pushed_user');
    const skuRow = this.columnDefs.find(x => x.field === 'sku');
    const updatedAtRow = this.columnDefs.find(x => x.field === 'updated_at');
    const changeByUserRow = this.columnDefs.find(x => x.field === 'changed_by');
    const statusRow = this.columnDefs.find(x => x.field === 'status');

    if (statusRow) {
      statusRow.hide = false;
    }

    if (changeByUserRow) {
      changeByUserRow.hide = false;
      changeByUserRow.sortable = false;
      changeByUserRow.suppressFiltersToolPanel = true;
      changeByUserRow.suppressColumnsToolPanel = false;
    }

    if (updatedAtRow) {
      updatedAtRow.hide = false;
      updatedAtRow.sortable = true;
      updatedAtRow.sort = 'desc';
      // sort: 'desc',
      updatedAtRow.suppressFiltersToolPanel = false;
      updatedAtRow.suppressColumnsToolPanel = false;
    }

    if (skuRow) {
      skuRow.pinned = null;
      skuRow.sort = null;
      skuRow.checkboxSelection = false;
    }

    if (confirmationRow) {
      confirmationRow.pinned = 'left';
      confirmationRow.hide = false;
      confirmationRow.suppressFiltersToolPanel = true;
      confirmationRow.suppressColumnsToolPanel = true;
    }
    if (pushedAtRow) {
      pushedAtRow.hide = true;
      pushedAtRow.suppressFiltersToolPanel = true;
      pushedAtRow.suppressColumnsToolPanel = true;
      pushedAtRow.sort = null;
    }
    if (pushedUserRow) {
      pushedUserRow.hide = true;
      pushedUserRow.suppressFiltersToolPanel = true;
      pushedUserRow.suppressColumnsToolPanel = true;
    }
  }

  ngOnDestroy(): void {
    this.gridService.changesSelectedItemsCount$.next(0);
  }

  onSelectionChanged(): void {
    const selectedRows: any = this.gridService.changesGridApi?.getSelectedRows();
    this.gridService.changesSelectedItemsCount$.next(selectedRows.length);
    console.log('🤲 selectedRows', selectedRows);
  }

  columnEverythingChanged($event: any): void {
    if (this.gridReady) {
      const savedState = this.gridService.changesColumnApi?.getColumnState();
      this.localStorageService.setItem('logsColumnState', savedState);
    }
  }

  filterChanged($event: any): void {
    const filterModel = this.gridService.changesGridApi?.getFilterModel();
    this.gridService.changesFilterIsActive$.next(!!(filterModel && Object.keys(filterModel).length));
  }

  onGridReady(params: GridReadyEvent) {
    setTimeout(() => {
      this.infoService.update();
    }, 500);
    this.gridService.changesGridApi = params.api;
    this.gridService.changesColumnApi = params.columnApi;
    const columnState = this.localStorageService.getItem('logsColumnState');
    params.columnApi?.applyColumnState({
      state: columnState,
      applyOrder: true
    });
    // this.gridApi = params.api;
    // this.columnApi = params.columnApi;

    const that = this;
    this.gridService.changesGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;

        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        // that.httpService.post(environment.API_PATH + '/log', body).subscribe((dataAndCount) => {
        that.httpService.post(environment.API_PATH + '/changes', body).subscribe({
          next: (dataAndCount) => {
            const receivedData = dataAndCount as { rows: {}[], count: number };
            that.gridReady = true;
            params.success({
              rowData: receivedData.rows,
              rowCount: receivedData.count
            });
          },
          error: (err) => {
            console.error('Failed to load changes data:', err);
            params.fail();
          }
        });
      }
    });
  }
}
